import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'

export function success(message) {
  ToastProgrammatic.open({
    message,
    type: 'success',
  })
}

export function error(message, exception = null) {
  ToastProgrammatic.open({
    message,
    type: 'danger',
  })
  if (exception) {
    console.log(exception)
  }
}
